import React from 'react';

function Contacto() {
  return (
    <div>
      <h1>Contacto</h1>
      <p>Información de contacto del municipio.</p>
    </div>
  );
}

export default Contacto;
